import { ANONYMOUS } from 'core';

export const COMMENT_COPY = {
  liked: 'Liked',
  like: 'Like',
  you: 'You',
  anonymous: ANONYMOUS,
};
